export default __webpack_public_path__ + "static/media/LarsseitBold.dc0d435f.woff";